export const getLocalStorageSize = () => JSON.stringify(localStorage).length;
